import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { ClearCanvasPayload, TemplateEdgeT, TemplateNodeT } from '../../../types/skeleton-template-builder.type';
import { selectedNodeIdAtom, templateEdgesAtom, templateNodesAtom } from '../template-atoms';
export const clearCanvasCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<ClearCanvasPayload, void> => {
  let previousNodes: TemplateNodeT[] = [];
  let previousEdges: TemplateEdgeT[] = [];
  let previousSelectedId: string | null = null;
  return {
    execute: () => {
      previousNodes = get(templateNodesAtom);
      previousEdges = get(templateEdgesAtom);
      previousSelectedId = get(selectedNodeIdAtom);
      set(templateNodesAtom, []);
      set(templateEdgesAtom, []);
      set(selectedNodeIdAtom, null);
    },
    undo: () => {
      set(templateNodesAtom, previousNodes);
      set(templateEdgesAtom, previousEdges);
      set(selectedNodeIdAtom, previousSelectedId);
    }
  };
};